import React from 'react';
import { IModalFormField } from '@components-member/socialTrading/social.interfaces';
import { INotificationWarning } from 'components/shared/shared.interfaces';
import { SelectedOptionDescription } from 'components/user/socialTrading/shared/selectMasterComponents/optionInfo/selectedOptionDescription';
import { OptionNotification } from 'components/user/socialTrading/shared/selectMasterComponents/optionNotification';
import { IInvestors, IMaster } from 'components/user/socialTrading/social.interfaces';

export const setMasterAdditionalInfo = (
  idx: number,
  fields: IModalFormField[],
  masterAccount: IMaster,
  description: string,
  investorWarnings: INotificationWarning,
  showDescription: boolean,
) => {
  setMasterAccountDescription(idx, fields, description, showDescription);

  setMasterAccountNotification(idx, fields, masterAccount, investorWarnings);
};

export const setMasterAccountNotification = (
  idx: number,
  fields: IModalFormField[],
  selectedMaster: IMaster,
  investorWarnings: INotificationWarning,
  selectedInvestor?: IInvestors,
) => {
  const notificationComponent = (
    <OptionNotification
      investorAccount={selectedInvestor}
      masterAccount={selectedMaster}
      notificationsWarning={investorWarnings}
    />
  );

  return (fields[idx] = Object.assign({
    ...fields[idx],
    notificationComponent,
  }));
};

export const setMasterAccountDescription = (
  idx: number,
  fields: IModalFormField[],
  description: string,
  showDescription: boolean,
) => {
  const descriptionComponent = showDescription && description && (
    <SelectedOptionDescription description={description} />
  );

  return (fields[idx] = Object.assign({
    ...fields[idx],
    descriptionComponent,
  }));
};
